module.exports = __webpack_public_path__ + "img/14.7b8eb956.jpg";